<template>
    <div style="position:relative;height: 100%">
        <Lists v-if="indexMenu === 'list'" @toIndex="toIndex" v-bind:tagMainData="tagMainData"/>
        <Labels v-if="indexMenu === 'label'" @toIndex="toIndex" v-bind:tagMainData="tagMainData"/>
        <Corpus v-if="indexMenu === 'corpus'" @toIndex="toIndex" v-bind:tagMainData="tagMainData"/>
    </div>
<!--    <robotKms app="voice1" />-->
</template>
<script>
import Corpus from './corpus'
import Labels from './label'
import Lists from './list'
import robotKms from '@xiaoi/aicc-robot/views/ai/kms/kmsImport/index.vue'
export default {
  name: 'index',
  components: { Corpus, Labels, Lists, robotKms },
  data() {
    return {
      indexMenu: 'list', // list label corpus
      tagMainData: {}
    }
  },
  methods: {
    toIndex(index, data) {
      this.tagMainData = data
      this.indexMenu = index
    }
  }
}
</script>
